import React from "react";
import logo from "assets/img/logo/logo_aig_login-2.png";

import {
  Card,
  CardBody,
  Row,
  Col,
  Label,
  Button,
  Alert
} from "reactstrap";

import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Textbox, Textarea, Radiobox, Select } from "react-inputs-validation";
import "../../styles/estilos.css";
import Page from "components/Page";
import LoadingScreen from "react-loading-screen";
import { fetchConsultarIdentificacionAP } from "../../redux/actions/aCotizacion";
import { fetchConsultarCarritoFinanciero, fetchGuardarCarritoFinanciero } from "../../redux/actions/aRamoLineaFinanciera";
import { encriptarTramaAES } from "../../utils/Encriptar/index";
import makeAnimated from 'react-select/lib/animated';
import Select1 from 'react-select';
import { urlDeduciblesRoles, urlListarCiudadesFinanciero } from '../../constants/urls'
import { FetchPost } from '../../redux/actions/api'
import { ambienteAplicacion } from "../../constants/urls";
import { EquiRamos, ErrorMsgConstants } from "../../constants";
import { estaEnListaNegra, isDuplicateHogar } from "../../redux/actions/ACarritoProductos";
import { ramos } from "../../utils/constants";

class CotizacionFinanciero extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      validate: false,
      idCarrito: this.props.preservar === 'si' ? this.props.detalleCarrito.ultimoPaso.resultado.idCarrito : '',
      empresa: "",
      nombreSubsidiaria: "",
      solicitante: "",
      ruc: "",
      rucSubsidiaria: "",
      direccion: "",
      factotal: "",
      factotalSeleccionado: "",
      provincia: "",
      ciudad: "",
      giroNegocio: "",
      surcursal: "",
      arrayCiudades: [],
      hasEmpresaError: true,
      hasnombreSubsidiariaError: new URLSearchParams(this.props.location.search).get('idProducto') == '120' ? true : false ,
      hasRucError: true,
      hasRucSubsidiariaError: new URLSearchParams(this.props.location.search).get('idProducto') == '120' ? true : false,
      hasDireccionError: true,
      hasProvinciaError: false,
      hasCiudadError: false,
      hasGiroNegocioError: true,
      hasSucursalError: true,
      cargandoCiudades: false,
      queryParams: new URLSearchParams(this.props.location.search),
      valAlerta: false,
      valCampos: false,
      codigoProd: new URLSearchParams(this.props.location.search).get('idProducto')
    };
    //this.validateForm = this.validateForm.bind(this);
  }

  toggleValidating = (validate) => {
    this.setState({ validate });
  }
  validateForm = async () => {
    this.toggleValidating(true);

    const {
      empresa,
      nombreSubsidiaria,
      solicitante,
      ruc,
      rucSubsidiaria,
      direccion,
      provincia,
      ciudad,
      giroNegocio,
      sucursal,
      hasSolicitanteError,
      hasSucursalError,
      hasEmpresaError,
      hasnombreSubsidiariaError,
      hasRucError,
      hasRucSubsidiariaError,
      hasDireccionError,
      hasProvinciaError,
      hasGiroNegocioError,
      hasCiudadError,
      factotal,
      factotalSeleccionado,
      queryParams,
      idCarrito
    } = this.state;



    if (provincia === "")
      this.setState({ hasProvinciaError: true })
    if (ciudad === "")
      this.setState({ hasCiudadError: true })
    if (giroNegocio === "")
      this.setState({ hasGiroNegocioError: true })

    // Determinar el tipo de responsabilidad civil
    const casoLineasFin = new URLSearchParams(this.props.location.search).get('idProducto');

    // Llamar al servicio de validación de duplicidad de poliza
    const checkDuplicidadObj = {
      empresa: "AIGMETROPOLITANA",
      plataforma: 'WEB',
      identificacion: ruc,
      ramo: casoLineasFin === '120' ? EquiRamos.dOExpress : EquiRamos.cyberEdge,
    };
    await this.props.checkIsDuplicate({ type: 'otros', postObj: checkDuplicidadObj });

    // si es que no existe duplicidad, continuar al siguiente paso
    if (!this.props.duplicity.isDuplicatePoliza) {
      // Asignar error falso, a los campos que no se utilizan en el formulario
      if (
        !hasEmpresaError &&
        (!hasnombreSubsidiariaError || this.state.codigoProd != '120') &&
        !hasDireccionError &&
        !hasProvinciaError &&
        !hasCiudadError &&
        !hasGiroNegocioError &&
        !hasSucursalError &&
        !this.props.duplicity.duplicidadPolizaError &&
        //(!hasSolicitanteError && hasSolicitanteError!== undefined) &&
        !hasRucError &&
        (!hasRucSubsidiariaError || this.state.codigoProd != '120') &&
        factotal != ""
      ) {


        const datosJSON = {
          codigoProducto: this.props.detalleCarrito.carSeguro !== undefined ? this.props.detalleCarrito.carSeguro : queryParams.get('idProducto'),
          nombreEmpresa: empresa,
          nombreSubsidiaria: nombreSubsidiaria,
          rucSubsidiaria: rucSubsidiaria,
          // nombreSolicitante: solicitante,
          numeroRuc: ruc,
          provNombre: provincia.label,
          provCodigoCore: provincia.provCodigoCore ? provincia.provCodigoCore : provincia.value,
          paiCodigoCore: provincia.paiCodigoCore,
          ciuCodigoCore: ciudad.value,
          ciuNombre: ciudad.label,
          direccionPrincipal: direccion,
          ingCodigoCore: factotal,
          idCarrito: idCarrito,
          asesorCodigoCore: this.props.datosUsuario.cliCodigoCore,
          cliCodigoCore: Object.keys(this.props.datosIdentificacion.IdentificacionAP).length > 0 ? this.props.datosIdentificacion.IdentificacionAP[0].mongoIdentificador : '',
          ambiente: ambienteAplicacion,
          giroNegocio: { id: giroNegocio.value, nombre: giroNegocio.label },
          sucursalSeleccionada: sucursal,
          datosAsesor: {
            nombre: `${this.props.datosAsesor.nombres} ${this.props.datosAsesor.apellidos}`,
            codigoCore: this.props.datosAsesor.cliCodigoCore,
            sucursalSeleccionada: sucursal,
            ambiente: ambienteAplicacion,
            emailAsesor: this.props.datosAsesor.correo ? this.props.datosAsesor.correo : '',
            brokerRUC: this.props.datosAsesor.brokerRUC ? this.props.datosAsesor.brokerRUC : '',
            brokerNombre: this.props.datosAsesor.brokerNombre ? this.props.datosAsesor.brokerNombre : '',
            brokerCodigo: this.props.datosAsesor.brokerCodigo ? this.props.datosAsesor.brokerCodigo : '',
          },
        }


        const auxCod = this.props.detalleCarrito.carSeguro !== undefined ? this.props.detalleCarrito.carSeguro : queryParams.get('idProducto')

        const datosJSON2 = {
          paso: "1",
          datosCliente: datosJSON
        }
        console.log('datosJson', datosJSON2)
        const encriptado = encriptarTramaAES(JSON.stringify(datosJSON2));

        var nombreProducto = ''
        var codigoProducto = 0





        switch (parseInt(auxCod)) {
          case 123:

            nombreProducto = 'Responsabilidad Civil Profesional Para Instituciones Educativas'
            codigoProducto = 4

            break;

          case 121:

            nombreProducto = 'CyberEdge Express'
            codigoProducto = 1

            break;

          case 120:

            nombreProducto = 'D&O Express'
            codigoProducto = 2

            break;

          case 122:

            nombreProducto = 'Responsabilidad Civil Profesional'
            codigoProducto = 3

            break;

          default:
            break;
        }


        const datosAsesor = {

          sucursalSeleccionada: this.props.datosSucursales
            .sucursalSelecionadaAsesor,

          ambiente: ambienteAplicacion,
          emailAsesor: this.props.datosUsuarios.correo
            ? this.props.datosUsuarios.correo
            : "",
          nombreProducto: nombreProducto,
          codigoProducto: codigoProducto,
          codigoRamo: ramos.LINEAS_FINANCIERAS.codigo,
          nombreRamo: ramos.LINEAS_FINANCIERAS.nombre,
        }

        await this.props.checkInListaNegra(ruc, datosAsesor)
        if (this.props.datosListaNegra.inListaNegra === false) {

          await this.props.guardarCarrito({ "Data": Buffer.from(JSON.stringify(encriptado)).toString('base64') });
          if (this.props.respuestaCarrito.respuestaGuardarFinanciero.errorDescripcion === undefined) {
            this.props.history.push({
              pathname: "/estatus-cotizacion-financiero",
              search: `?${new URLSearchParams({
                preservar: this.props.preservar
              }).toString()
                }`
            });
          } else {
            this.setState({
              valAlerta: true,
              idCarrito: this.props.respuestaCarrito.respuestaGuardarFinanciero.idCarrito
            });
          }

        }




      } else {
        this.setState({
          valCampos: true
        });

      }
    }
  }

  onChangeProvincia = async (provincia) => {
    this.setState({ cargandoCiudades: true })
    let resp = await FetchPost({
      url: urlListarCiudadesFinanciero, param: {
        empresa: "AIGMETROPOLITANA",
        codProvincia: provincia,
        ramo: "lineasFinancieras"
      }
    })
    const { transaccion, ciudades } = resp
    if (transaccion) {
      this.setState({ arrayCiudades: ciudades })
    }
    this.setState({ cargandoCiudades: false })
  }

  /**
   * 
   * @param {{identificacion,tipo}}} params Número y tipo de identificación de la persona
   * Función para consultar la identidad de una persona y llenar los campos del formulario
   */
  cambiarRucId = async params => {
    const { identificacion, tipo, rol } = params;
    let datos = '';

    await this.props.consultarIdentificacion({
      "empresa": "AIGMETROPOLITANA",
      "identificador": identificacion,
      "tipo": tipo
    })

    let prov = '';
    let ciu = '';
    let valSelect = true;


    if (rol === 'normal') {
      if (Object.keys(this.props.datosIdentificacion.IdentificacionAP).length > 0) {
        datos = this.props.datosIdentificacion.IdentificacionAP[0];

        const { nombre = '', mongoIdentificador = '', direccion = '', paiCodigoCore = '', provCodigoCore = '', provNombre = '', ciuCodigoCore = '', ciuNombre = '' } = datos;

        if (provCodigoCore !== '' && provCodigoCore !== undefined && provCodigoCore !== null) {
          await this.onChangeProvincia(provCodigoCore);
          prov = {
            value: `${provCodigoCore ? provCodigoCore : ""}`,
            label: `${provNombre ? provNombre : ""}`,
            paiCodigoCore: `${paiCodigoCore ? paiCodigoCore : ""}`
          };

          ciu = {
            value: `${ciuCodigoCore ? ciuCodigoCore : ""}`,
            label: `${ciuNombre ? ciuNombre : ""}`
          };
          valSelect = false;
        }

        if (tipo === "ruc") {
          this.setState({
            empresa: `${nombre}`,
            direccion: `${direccion}`,
            cliCodigoCore: `${mongoIdentificador}`,
            provincia: prov,
            ciudad: ciu,
            hasProvinciaError: valSelect,
            hasCiudadError: valSelect,
            validate: false,
            hasEmpresaError: false
          });
        }
      } else {
        if (tipo === "ruc") {
          this.setState({
            empresa: "",
            direccion: "",
            cliCodigoCore: "",
            provincia: prov,
            ciudad: ciu,
            hasProvinciaError: valSelect,
            hasCiudadError: valSelect,
            validate: false,
            hasEmpresaError: true
          });
        }
      }

    }
    if (rol === 'subsidiaria') {

      console.log('hola', this.props.datosIdentificacion.IdentificacionAP)

      if (Object.keys(this.props.datosIdentificacion.IdentificacionAP).length > 0) {

        datos = this.props.datosIdentificacion.IdentificacionAP[0];

        const { nombre = '' } = datos;

        this.setState(
          {
            nombreSubsidiaria: `${nombre}`,
          }
        )

      } else {

        this.setState(
          {
            nombreSubsidiaria: ``,
          }
        )

      }




    }



    setTimeout(() => this.setState({ validate: true }), 100)
    // document.getElementById("empresa").focus();
    //   document.getElementById("ruc").focus();
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.props.detalleCarrito !== prevProps.detalleCarrito)
      this.recuperarCarrito();
  }

  componentDidMount() {
    window.scroll(0, 0);
    this.recuperarCarrito();

  }

  async recuperarCarrito() {
    const { detalleCarrito } = this.props;

    const factSeleccionado = detalleCarrito.ingresos ? { value: detalleCarrito.ingresos.ingCodigoCore, label: detalleCarrito.ingresos.ingDescripcion } : null

    if ((Object.keys(detalleCarrito).length > 0) && (detalleCarrito.datosCliente)) {
      await this.onChangeProvincia(detalleCarrito.datosCliente.provCodigoCore);
      this.setState({
        idCarrito: detalleCarrito.ultimoPaso.resultado.idCarrito,
        empresa: detalleCarrito.datosCliente.nombre,
        nombreSubsidiaria: detalleCarrito.datosCliente.nombreSubsidiaria,
        rucSubsidiaria: detalleCarrito.datosCliente.rucSubsidiaria,
        // solicitante: Object.keys(this.props.detalleCarrito).length > 0 ? this.props.detalleCarrito.datosCliente.nombreSolicitante : "",
        provincia: { value: detalleCarrito.datosCliente.provCodigoCore, label: detalleCarrito.datosCliente.provNombre, paiCodigoCore: detalleCarrito.datosCliente.paiCodigoCore, },
        ciudad: { value: detalleCarrito.datosCliente.ciuCodigoCore, label: detalleCarrito.datosCliente.ciuNombre },
        ruc: detalleCarrito.datosCliente.cedula,
        direccion: detalleCarrito.datosCliente.direccionPrincipal,
        factotal: detalleCarrito.ingresos.ingCodigoCore,
        factotalSeleccionado: factSeleccionado,
        giroNegocio: { value: detalleCarrito.datosCliente.giroNegocio.id, label: detalleCarrito.datosCliente.giroNegocio.nombre },
        sucursal: detalleCarrito.datosAsesor.sucursalSeleccionada,
        hasEmpresaError: false,
        hasRucError: false,
        hasRucSubsidiariaError: false,
        hasDireccionError: false,
        hasSucursalError: false,
        hasGiroNegocioError: false,
      })
    }
    else {
      this.setState({
        idCarrito: "",
        empresa: "",
        solicitante: "",
        ruc: "",
        direccion: "",
        factotal: "",
        provincia: "",
        ciudad: "",
        giroNegocio: "",
        sucursal: "",
        hasEmpresaError: true,
        hasRucError: true,
        hasRucSubsidiariaError: this.state.codigoProd == '120' ? true : false,
        hasDireccionError: true,
        hasSucursalError: true,
      })

    }
  }

  textosCargando() {
    const { cargandoCiudades } = this.state;
    if (this.props.respuestaCarrito.guardarCarritoFinancieroIsLoading)
      return "Guardando información. Por favor espere..."
    if (this.props.datosIdentificacion.consultarIdentificacionAPIsLoading)
      return "Cargando datos..."
    if (cargandoCiudades)
      return "Consultado ciudades..."
  }
  render() {
    const { validate, empresa, nombreSubsidiaria, solicitante, provincia, ciudad, ruc, rucSubsidiaria, direccion, factotal, factotalSeleccionado, giroNegocio, sucursal, valAlerta, valCampos, hasGiroNegocioError, hasProvinciaError, hasCiudadError, arrayCiudades, cargandoCiudades } = this.state;
    const { respuestaCarrito, datosIdentificacion, listarIngresos, listarProvincias, listaGirosNegocio, listaSucursales, Cotizador } = this.props;

    let arraySucursales = [];
    listaSucursales.map(s => {
      arraySucursales.push({ id: s.sucCodigoCore, name: s.sucNombre });
    });
    arraySucursales.unshift({ id: '', name: 'Seleccione una opción' });

    return (
      <LoadingScreen
        loading={datosIdentificacion.consultarIdentificacionAPIsLoading ||
          respuestaCarrito.guardarCarritoFinancieroIsLoading ||
          cargandoCiudades ||
          this.props.duplicity.duplicidadPolizaLoading
        }
        bgColor="#f1f1f1"
        spinnerColor="#001871"
        textColor="#676767"
        logoSrc={logo}
        text={this.textosCargando()}
      >
        <Page
          title={Cotizador}
          breadcrumbs={[{ name: `${Cotizador}`, active: true }]}

        >
          <div className="container-step">
            <div className="wrapper-step">
              <div className="arrow-steps clearfix-step">
                <div className="step current"> {` 1. Cotización `} </div>
                <div className="step"> {` 2. Resumen `} </div>
                <div className="step"> {` 3. Confirmación `} </div>
                <div class="step"> {` 4. Forma de Pago `} </div>
                <div class="step"> {` 5. Formulario de Vinculación `} </div>
                <div class="step"> {` 6. Emisión `} </div>
              </div>
            </div>
          </div>
          <Row>
            <Col lg={8} md={12} sm={12} xs={12} className="div-align-center">
              <Card className="flex-row ">
                <CardBody>
                  <h4 style={{ fontWeight: "bold" }} className='mb-5'> Datos del cliente </h4>
                  <Row>
                    <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                      <h5><Label className="bold-font-label" >RUC (*) </Label></h5>
                    </Col>
                    <Col lg={8} md={8} sm={12} xs={12} className="mb-3">
                      <Col lg={8} md={8} sm={12} xs={12}>
                        <Textbox
                          tabIndex="1"
                          type="text"
                          value={ruc}
                          name="ruc"
                          id="ruc"
                          classNameInput={"form-control"}
                          onBlur={() => { this.setState({ valAlerta: false, valCampos: false }); }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                          onChange={(ruc, e) => {
                            this.setState({ ruc: ruc, valAlerta: false, valCampos: false });
                            if (ruc.length === 13) {
                              this.cambiarRucId({ identificacion: ruc, tipo: "ruc", rol: 'normal' })
                            }
                          }}
                          validate={validate}
                          validationCallback={res => this.setState({ hasRucError: res })}// Optional.[Func].Default: none. Return the validation result.
                          validationOption={{
                            name: "ruc", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            required: true,
                            reg: /^\d{13}$/, //Optional.[Bool].Default: "" Custom regex.
                            msgOnError: "Por favor ingrese un RUC correcto" // Optional.[Bool].Default: true. To determin if it is a required field.
                          }}
                        />
                      </Col>

                    </Col>
                  </Row>
                  <Row>
                    <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                      <h5><Label className="bold-font-label" >Nombre de la empresa (*)  </Label></h5>
                    </Col>
                    <Col lg={8} md={8} sm={12} xs={12} className="mb-3">
                      <Col lg={8} md={8} sm={12} xs={12}>
                        <Textarea
                          tabIndex="1"
                          type="input"
                          value={empresa}
                          name="empresa"
                          id="empresa"
                          classNameInput={"form-control"}
                          onChange={(empresa, e) => {
                            this.setState({
                              empresa: empresa.toUpperCase(),
                              hasEmpresaError: false,
                              valAlerta: false, valCampos: false
                            });
                          }}
                          validate={validate}
                          validationCallback={res => {
                            this.setState({
                              hasEmpresaError: res,
                              validate: !res
                            });
                          }} // Optional.[Func].Default: none. Return the validation result.
                          onBlur={e => {
                            this.setState({ blur: true, valAlerta: false, valCampos: false });

                          }}
                          validationOption={{
                            name: "empresa", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your {name}.
                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            required: false, // Optional.[Bool].Default: true. To determin if it is a required field.
                            //msgOnError: "Debe ingresar una dirección." // Optional.[Bool].Default: true. To determin if it is a required field.
                            customFunc: res => {
                              //Optional.[Func].Default: none. Custom function. Returns true or err message
                              res = empresa;
                              if (
                                res === "" ||
                                res === null ||
                                res === undefined
                              ) {
                                this.setState({ empresa: "" });
                                return "Por favor ingrese el nombre de la empresa.";
                              }
                              return true;
                            }
                          }}
                        />
                      </Col>

                    </Col>
                  </Row>
                  {/* <Row>
                    <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                      <h5><Label className="bold-font-label" >Nombre del solicitante(*) </Label></h5>
                    </Col>
                    <Col lg={8} md={8} sm={12} xs={12} className="mb-3">
                      <Col lg={8} md={8} sm={12} xs={12}>
                        <Textbox
                          tabIndex="1"
                          type="text"
                          value={solicitante}
                          name="solicitante"
                          id="solicitante"
                          classNameInput={"form-control"}
                          onChange={(solicitante, e) => {
                            this.setState({ solicitante: solicitante, valAlerta: false, valCampos: false});
                          }}
                          onBlur={() => {this.setState({ valAlerta: false, valCampos: false}); }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                          validate={validate}
                          validationCallback={res => this.setState({ hasSolicitanteError: res })}// Optional.[Func].Default: none. Return the validation result.
                          validationOption={{
                            name: "solicitante", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            reg: /^[\u00e1\u00e9\u00ed\u00f3\u00fa\u00c1\u00c9\u00cd\u00d3\u00da\u00f1\u00d1A-Za-z _]*$/,
                            required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                            msgOnError: "Por favor ingrese el nombre del solicitante" // Optional.[Bool].Default: true. To determin if it is a required field.
                          }}
                        />
                      </Col>
                    </Col>
                  </Row> */}
                  <Row>
                    <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                      <h5><Label className="bold-font-label" >Provincia (*)</Label></h5>
                    </Col>
                    <Col lg={8} md={8} sm={12} xs={12} className="mb-3">
                      <Col lg={8} md={8} sm={12} xs={12}>
                        <Select1
                          value={provincia}
                          components={makeAnimated()}
                          onChange={(provincia, e) => {
                            this.setState({
                              provincia: provincia,
                              ciudad: '',
                              hasProvinciaError: false
                            });
                            this.onChangeProvincia(provincia.value.toString())
                          }}
                          options={listarProvincias}
                          isSearchable={true}
                          placeholder={"Seleccione una provincia"}
                          isMulti={false}
                        />
                        {hasProvinciaError &&
                          <span style={{ color: "#ff5a57", fontSize: "1rem", marginLeft: "5px" }}>Por favor seleccione una provincia</span>
                        }
                      </Col>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                      <h5><Label className="bold-font-label" >Ciudad (*)</Label></h5>
                    </Col>
                    <Col lg={8} md={8} sm={12} xs={12} className="mb-3">
                      <Col lg={8} md={8} sm={12} xs={12}>
                        <Select1
                          value={ciudad}
                          components={makeAnimated()}
                          onChange={(ciudad, e) => {
                            this.setState({
                              ciudad: ciudad,
                              hasCiudadError: false
                            });
                          }}
                          options={arrayCiudades}
                          isSearchable={true}
                          placeholder={"Seleccione una ciudad"}
                          isMulti={false}
                        />
                        {hasCiudadError &&
                          <span style={{ color: "#ff5a57", fontSize: "1rem", marginLeft: "5px" }}>Por favor seleccione una ciudad</span>
                        }
                      </Col>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                      <h5><Label className="bold-font-label" >Direción principal de la empresa solicitante (*)</Label></h5>
                    </Col>
                    <Col lg={8} md={8} sm={12} xs={12} className="mb-3">
                      <Col lg={8} md={8} sm={12} xs={12}>
                        <Textarea
                          // tabIndex="1"
                          type="text"
                          value={direccion}
                          name="direccion"
                          id="direccion"
                          classNameInput={"form-control"}
                          validate={validate}
                          onChange={(direccion, e) => {
                            this.setState({ direccion: direccion.toUpperCase(), valAlerta: false, valCampos: false });
                          }}
                          onBlur={() => { this.setState({ valAlerta: false, valCampos: false }); }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                          validationCallback={res => this.setState({ hasDireccionError: res, validate: res })}// Optional.[Func].Default: none. Return the validation result.
                          validationOption={{
                            name: 'direccion', // Optional.[String].Default: "". To display in the Error message. i.e Please enter your {name}.
                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            required: false, // Optional.[Bool].Default: true. To determin if it is a required field.
                            //msgOnError: "Debe ingresar una dirección." // Optional.[Bool].Default: true. To determin if it is a required field.
                            customFunc: res => {
                              //Optional.[Func].Default: none. Custom function. Returns true or err message
                              res = direccion
                              if (res === "" || res === null || res === undefined) {
                                this.setState({ direccion: "" });
                                return "Por favor ingrese una dirección.";
                              }
                              return true;
                            }
                          }}
                        />
                      </Col>
                    </Col>
                  </Row>
                  <hr></hr>
                  <h4 style={{ fontWeight: "bold" }} className='mb-5'> Datos de la empresa </h4>
                  <Row>
                    <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                      <h5><Label className="bold-font-label" >Facturación Total (*)</Label></h5>

                      <Label>Ingresos brutos totales anuales</Label><br></br>
                      {this.state.codigoProd == '120' &&
                       <small>En caso de solicitar cobertura para subsidiarias que cumplan los parámetros del condicionado general Private Edge Pymes, detallar ingresos brutos totales anuales de manera consolidada</small>
                      }
                     
                    </Col>
                    <Col lg={8} md={8} sm={12} xs={12} className="mb-3">
                      <Col lg={8} md={8} sm={12} xs={12}>


                        <Select1
                          value={factotalSeleccionado}
                          components={makeAnimated()}
                          onChange={
                            (factotal, e) => {



                              this.setState({ factotal: factotal.value, factotalSeleccionado: factotal, valAlerta: false, valCampos: false })
                            }
                          }
                          options={listSlct(listarIngresos)}
                          isSearchable={true}
                          placeholder={"Seleccione la Facturación Tota"}
                          isMulti={false}
                        />
                        {!factotalSeleccionado &&
                          <span style={{ color: "#ff5a57", fontSize: "1rem", marginLeft: "5px" }}>Por favor seleccione una opción</span>
                        }
                      </Col>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                      <h5><Label className="bold-font-label" >Giro de Negocio (*)</Label></h5>
                    </Col>
                    <Col lg={8} md={8} sm={12} xs={12} className="mb-3">
                      <Col lg={8} md={8} sm={12} xs={12}>
                        <Select1
                          value={giroNegocio}
                          components={makeAnimated()}
                          onChange={(giroNegocio, e) => {
                            this.setState({
                              giroNegocio,
                              hasGiroNegocioError: false,
                              valAlerta: false, valCampos: false
                            });
                          }}
                          options={listaGirosNegocio}
                          isSearchable={true}
                          placeholder={"Seleccione un giro de negocio"}
                          isMulti={false}
                        />
                        {hasGiroNegocioError &&
                          <span style={{ color: "#ff5a57", fontSize: "1rem", marginLeft: "5px" }}>Por favor seleccione un giro de negocio</span>
                        }
                      </Col>
                    </Col>
                  </Row>

                  {this.state.codigoProd == '120' &&

                    <React.Fragment>
                      <Row>
                        <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                          <h5><Label className="bold-font-label" >RUC de subsidiaria </Label></h5>

                        </Col>

                        <Col lg={8} md={8} sm={12} xs={12} className="mb-3">
                          <Col lg={8} md={8} sm={12} xs={12}>
                            <Textbox
                              tabIndex="1"
                              type="text"
                              value={rucSubsidiaria}
                              name="rucSubsidiaria"
                              id="rucSubsidiaria"
                              classNameInput={"form-control"}
                              onBlur={() => { this.setState({ valAlerta: false, valCampos: false }); }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                              onChange={(rucSubsidiaria, e) => {
                                this.setState({ rucSubsidiaria: rucSubsidiaria, valAlerta: false, valCampos: false });
                                if (rucSubsidiaria.length === 13) {
                                  this.cambiarRucId({ identificacion: rucSubsidiaria, tipo: "ruc", rol: 'subsidiaria' })
                                }
                              }}
                              validate={validate}
                              validationCallback={res => this.setState({ hasRucSubsidiariaError: res })}// Optional.[Func].Default: none. Return the validation result.
                              validationOption={{
                                name: "rucSubsidiaria", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                                check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                required: false,
                                reg: /^\d{13}$/, //Optional.[Bool].Default: "" Custom regex.
                                msgOnError: "Por favor ingrese un RUC correcto" // Optional.[Bool].Default: true. To determin if it is a required field.
                              }}
                            />

                          </Col>
                        </Col>

                      </Row>
                      <Row>
                        <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                          <h5><Label className="bold-font-label" >Nombre de subsidiaria </Label></h5>

                        </Col>

                        <Col lg={8} md={8} sm={12} xs={12} className="mb-3">
                          <Col lg={8} md={8} sm={12} xs={12}>
                            <Textarea
                              tabIndex="1"
                              type="input"
                              value={nombreSubsidiaria}
                              name="nombreSubsidiaria"
                              id="nombreSubsidiaria"
                              classNameInput={"form-control"}
                              onChange={(nombreSubsidiaria, e) => {
                                this.setState({
                                  nombreSubsidiaria: nombreSubsidiaria.toUpperCase(),
                                  hasnombreSubsidiariaError: false,
                                  valAlerta: false, valCampos: false
                                });
                              }}
                              validate={validate}
                              validationCallback={res => {
                                this.setState({
                                  hasnombreSubsidiariaError: res,
                                  validate: !res
                                });
                              }} // Optional.[Func].Default: none. Return the validation result.
                              onBlur={e => {
                                this.setState({ blur: true, valAlerta: false, valCampos: false });

                              }}
                              validationOption={{
                                name: "nombreSubsidiaria", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your {name}.
                                check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                required: false, // Optional.[Bool].Default: true. To determin if it is a required field.
                                //msgOnError: "Debe ingresar una dirección." // Optional.[Bool].Default: true. To determin if it is a required field.

                              }}
                            />

                          </Col>
                        </Col>

                      </Row>

                    </React.Fragment>
                  }






                  <hr></hr>
                  <h4 style={{ fontWeight: "bold" }} className='mb-5'> Sucursal de emisión</h4>
                  <Row>
                    <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                      <h5><Label className="bold-font-label" >Sucursal (*)</Label></h5>
                    </Col>
                    <Col lg={8} md={8} sm={12} xs={12} className="mb-3">
                      <Col lg={8} md={8} sm={12} xs={12}>
                        <Select
                          //tabIndex="6" // Optional.[String or Number].Default: none.
                          id={"selecSucursal"} // Optional.[String].Default: "". Input ID.
                          name={"selecSucursal"} // Optional.[String].Default: "". Input name.
                          value={sucursal} // Optional.[String].Default: "".
                          validate={validate}
                          optionList={arraySucursales} // Required.[Array of Object(s)].Default: [].
                          onChange={(sucursal, e) => this.setState({ sucursal, valAlerta: false, valCampos: false, hasSucursalError: sucursal ? false : true })}
                          onBlur={() => { this.setState({ valAlerta: false, valCampos: false }); }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                          validationCallback={res => this.setState({ hasSucursalError: res, validate: false })}// Optional.[Func].Default: none. Return the validation result.                                                                  
                          customStyleOptionListContainer={{ maxHeight: '200px', overflow: 'auto', fontSize: '14px' }} // Optional.[Object].Default: {}.
                          validationOption={{
                            name: "selecSucursal", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                            msgOnError: "Por favor seleccione una sucursal"
                          }}
                        />
                      </Col>
                    </Col>
                  </Row>
                  {valAlerta &&
                    <Row >
                      <Col lg={12} md={12} sm={12} xs={12} className="div-align-center">
                        <Alert color="warning">
                          <p style={{ textAlign: "center" }}><i className="fa fa-exclamation-triangle fa-3x" aria-hidden="true" ></i></p>
                          <p>{respuestaCarrito.respuestaGuardarFinanciero.errorDescripcion}</p>

                        </Alert>
                      </Col>
                    </Row>
                  }
                  {valCampos &&
                    <Row >
                      <Col md={10} sm={12} className="div-align-center">
                        <Alert color="danger">
                          <p style={{ textAlign: "center" }}><i className="fa fa-exclamation-triangle fa-2x" aria-hidden="true" ></i></p>
                          <p style={{ textAlign: "center" }}>{"Para continuar debe ingresar los campos obligatorios marcados con (*)"}</p>

                        </Alert>
                      </Col>
                    </Row>
                  }
                  <Row>
                    <div className="div-align-rigth">
                      <Button className="btn btn-primary" onClick={this.validateForm} style={{ display: "block", margin: "auto" }} >
                        <i className="fa fa-chevron-circle-right" aria-hidden="true" />{" "}
                        {"CONTINUAR"}
                      </Button>
                    </div>
                  </Row>
                  {/* Mensaje de error*/}
                  <div style={{ marginTop: '2rem' }}>
                    {/* Validacion de duplicidad */}

                    {this.props.duplicity.isDuplicatePoliza
                      ?
                      <Alert color="danger">
                        <center><p>{ErrorMsgConstants.duplicidad}</p></center>
                      </Alert>
                      :
                      null
                    }
                    {this.props.duplicity.duplicidadPolizaError &&
                      <Alert color="danger" >
                        <center><p>{ErrorMsgConstants.errorServicioDuplicidad}</p></center>
                      </Alert>
                    }

                    <div style={{ marginTop: '2rem' }}>
                      {/* Validacion de duplicidad */}
                      {console.log('test dup msg', this.props.datosListaNegra)}
                      {this.props.datosListaNegra.inListaNegra
                        ?
                        <Alert color="danger">
                          <center><p>{this.props.datosListaNegra.inListaNegraMensaje}</p></center>
                        </Alert>
                        :
                        null
                      }
                      {this.props.datosListaNegra.listaNegraError &&
                        <Alert color="danger">
                          <center><p>{ErrorMsgConstants.errorServicioListaNegra}</p></center>
                        </Alert>
                      }
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Page>
      </LoadingScreen>

    );
  }
}

const listSlct = (list) => {



  const formatList = []
  for (const idx in list) {
    formatList.push({
      value: list[idx].id,
      label: list[idx].name
    })
  }



  // return
  return formatList
}

const mapStateToProps = state => ({
  datosIdentificacion: state.datosIdentificacionAP,
  respuestaCarrito: state.datosCotizacionFinanciero,
  datosUsuario: state.datosUsuarios.dataUsuario,
  datosAsesor: state.datosUsuarios.dataUsuario,
  duplicity: state.datosDuplicidadPolizas,
  datosListaNegra: state.datosListaNegra,
  datosUsuarios: state.datosUsuarios.dataUsuario,
  datosSucursales: state.datosSucursales
});

const mapDispatchToProps = dispatch => {
  return {
    consultarIdentificacion: datos => dispatch(fetchConsultarIdentificacionAP(datos)),
    guardarCarrito: data => dispatch(fetchGuardarCarritoFinanciero(data)),
    checkIsDuplicate: (datosCheckDuplicity) => dispatch(isDuplicateHogar(datosCheckDuplicity)),
    consultarCarrito: (data) => dispatch(fetchConsultarCarritoFinanciero(data)),
    checkInListaNegra: (identificacion, datos) => dispatch(estaEnListaNegra(identificacion, datos)),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CotizacionFinanciero)
);
